import { useMemo } from 'react';
import { useDetailViewContext } from '../../../context/DetailViewContext';
import { DetailSectionIDs } from '../../../data/Sections';
import { MathUtils } from 'three';

/**
 * This is used to show a transition from one section to another if the detail view is already open. If closed, it will
 * go to the "to" section immediately.
 */
export default function useSimpleTransition(from: DetailSectionIDs, to: DetailSectionIDs): number
{
  const { detailIndex, getDetailIndexForID } = useDetailViewContext();
  const fromDetailIndex = useMemo(() => getDetailIndexForID(from), [ getDetailIndexForID, from ]);
  const toDetailIndex = useMemo(() => getDetailIndexForID(to), [ getDetailIndexForID, to ]);

  return useMemo(
    () => MathUtils.smoothstep(detailIndex, fromDetailIndex, toDetailIndex),
    [detailIndex, fromDetailIndex, toDetailIndex]
  );
}